import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SendOutlinedSvg from "@ant-design/icons-svg/es/asn/SendOutlined";
import AntdIcon from '../components/AntdIcon';
var SendOutlined = function SendOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: SendOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(SendOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'SendOutlined';
}
export default RefIcon;